import axios from 'axios'// 引入axios
import env from '../http/env'
import router from '../router'
import Vue from 'vue'
import { Promise } from 'core-js'
import qs from 'qs'
import logger from '../utils/logger'
// application/json;charset=UTF-8;
// 创建axios实例
const service = axios.create({
  // 这里拿线上接口测试
  baseURL: env.baseIP,
  headers: { // 请求头
    'Content-Type': 'application/json;charset=UTF-8;'
  },
  settimeout: 10000 // 超时时间
})
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 根据 showLoading 字段决定是否显示加载状态，默认不显示
    if (config.showLoading && Vue.$showLoading) {
      Vue.$showLoading.show()
    }
    if (localStorage.getItem('Authorization')) {
      config.headers.Authorization = localStorage.getItem('Authorization')
    }
    if (config.method === 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    return config // 记得一定要 返回config
  },
  error => {
    // 请求错误时隐藏加载状态
    if (error.config && error.config.showLoading && Vue.$showLoading) {
      Vue.$showLoading.hide()
    }
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use((res) => {
  // 响应成功时隐藏加载状态
  if (res.config && res.config.showLoading && Vue.$showLoading) {
    Vue.$showLoading.hide()
  }
  if (res.status && res.status === 200) {
    if (res.headers && res.headers.authorization) {
      const authorization = res.headers.authorization
      localStorage.setItem('Authorization', authorization)
    }
    if (res.data.code === 200 || res.data.code === 4002 || res.data.code === 3009) {
      return res.data
    } else if (res.data.code === 2014) { // 有未完善的资料
      Vue.prototype.$confirm('您有未完善的信息，是否现在去完善?', '提示', {
        confirmButtonText: '去完善',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        router.push({
          path: '/cebsbUserInfo?pushUrl=/speRegisterFirCompetition'
        })
      }).catch(() => {
      })
    } else if (res.data.code === 401) {
      Vue.prototype.$message.error('登录已过期，请重新登录！')
      localStorage.removeItem('Authorization')
      localStorage.removeItem('LOGIN_TYPE')
      localStorage.removeItem('SYS_USER')
      localStorage.removeItem('SYS_USER_SCHOOL')
      localStorage.removeItem('REGISTRATION_STATUS')
      router.push({
        path: '/HomeView',
        params: {
          pushUrl: ''
        }
      })
      this.$store.commit('SET_ACTIVEMENUINDEX', 0)
    } else {
      // 如果有 engMsg，则显示双语提示内容（换行显示）
      if (res.data.engMsg) {
        Vue.prototype.$message({
          message: `${res.data.msg}<br/>${res.data.engMsg}`,
          type: 'error',
          dangerouslyUseHTMLString: true
        })
      } else {
        Vue.prototype.$message.error(res.data.msg)
      }
    }
    return Promise.reject(res)
  }
}, err => {
  // 响应错误时隐藏加载状态
  if (err.config && err.config.showLoading && Vue.$showLoading) {
    Vue.$showLoading.hide()
  }
  logger.debug('request', 'err', err)
  if (err.code === 'ERR_BAD_RESPONSE') {
    if (err.response.data.code === 401) {
      Vue.prototype.$message.error('登录已过期，请重新登录！')
      localStorage.removeItem('Authorization')
      localStorage.removeItem('LOGIN_TYPE')
      localStorage.removeItem('SYS_USER')
      localStorage.removeItem('SYS_USER_SCHOOL')
      localStorage.removeItem('REGISTRATION_STATUS')
      router.push({
        path: '/HomeView',
        params: {
          pushUrl: ''
        }
      })
      this.$store.commit('SET_ACTIVEMENUINDEX', 0)
    } else {
      Vue.prototype.$message.error('无服务，请稍后重试！')
    }
  } else {
    if (err.status === 401) {
      Vue.prototype.$message.error('登录已过期，请重新登录！')
      localStorage.removeItem('Authorization')
      localStorage.removeItem('LOGIN_TYPE')
      localStorage.removeItem('SYS_USER')
      localStorage.removeItem('SYS_USER_SCHOOL')
      localStorage.removeItem('REGISTRATION_STATUS')
      router.push({
        path: '/HomeView',
        params: {
          pushUrl: ''
        }
      })
      this.$store.commit('SET_ACTIVEMENUINDEX', 0)
    } else {
      Vue.prototype.$message.error('无服务，请稍后重试！')
    }
  }
  return Promise.reject(err)
})
export default service
